module.exports = __webpack_public_path__ + "media/industry_tag_icon/biz_trading-d5c9ed8b.png";